import { Injectable } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { PolicyContext } from '../policy-context/policy-context.types';

@Injectable()
export class PolicyContextService {
  constructor(route: ActivatedRoute) {
    const owningRoute = this.findContext(route, 'policyContext');
    this.policyContext = owningRoute?.snapshot.data.policyContext;
    owningRoute?.data.subscribe((d) => {
      this.policyContext = d.policyContext;
    });
  }

  private policyContext: PolicyContext;

  get() {
    return this.policyContext;
  }

  private findContext(route: ActivatedRoute, contextName: string): ActivatedRoute | undefined {
    let currentRoute: ActivatedRoute | null = route;
    while (currentRoute) {
      const snapshot = currentRoute.snapshot;
      if (snapshot.data[contextName] !== undefined) {
        return currentRoute;
      }

      currentRoute = currentRoute.parent;
    }

    return undefined;
  }
}
